import React, { Fragment } from 'react'
import { connect } from 'react-redux'
import {
  change as changeFieldValue, Field, formValueSelector, reduxForm
} from 'redux-form';
import {
  maxValueMonetario,
  renderFieldMonetarioLabelEncima, renderFieldNumeros, renderFieldPercentual, renderFieldSelect, renderFieldText, required, requiredSelect
} from '../../util/inputs';
import { arredondamentoPadrao, realParaNumber } from '../../util/numberUtil';
import FormCadastroNotaFiscal from './FormCadastroNotaFiscal';
import adicionarDadosPagamentoEncomenda from '../../actions/encomenda/adicionarDadosPagamentoEncomenda';
import FormCadastrarFormaPagamentoEncomenda from './FormCadastrarFormaPagamentoEncomenda';
import { tamanhoArquivoUpload, LIMITE_UPLOAD_ARQUIVO_ENCOMENDA } from '../../util/applicationContext';
import { gerarHashForString } from '../../util/stringUtil';
import FormasPagamento from './FormasPagamento';
import NotasFiscais from './NotasFiscais';
import { showAlertMsg } from '../../util/messagesUtil';
import adicionaEhRemoveImagensEncomenda from '../../actions/encomenda/adicionaEhRemoveImagensEncomenda';
import ImageGridUpload from './ImageGridUpload';
import Modal from './Modal';

const selector = formValueSelector('formularioCadastroEncomenda');
export const VALORCOMBINADO = 'VALOR_COMBINADO';
export const VALORPORKG = 'VALOR_POR_KG';
export const PRECOFIXOMAISVALORPORKG = 'PRECO_FIXO_MAIS_VALOR_POR_KG';
export const VALOR_POR_METRO_CUBICO = 'VALOR_POR_METRO_CUBICO';

const novoItemMetroCubico = () => ({
  id: `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`,
  descricao: '',
  comprimento: '',
  largura: '',
  altura: ''
});

const parseDimensaoCm = (v) => {
  if (v === '' || v === undefined || v === null) return 0;
  return Number(String(v).replace(/\./g, '').replace(',', '.')) || 0;
};

const volumeUnitarioM3 = (c, l, a) => arredondamentoPadrao((parseDimensaoCm(c) * parseDimensaoCm(l) * parseDimensaoCm(a)) / 1000000);

export class AbaPagamento extends React.Component {
  constructor(props) {
    super(props);
    this.alterarTipoCalculo = this.alterarTipoCalculo.bind(this);

    this.state = {
      habilitadoValorDeclarado: false,
      habilitaValorNotaFiscal: false,
      arquivos: [],
      selectedImg: null
    }
  }

  componentDidMount() {
    if (this.props.dadosPagamentoEncomenda.habilitadoSeguro) {
      if (this.props.dadosPagamentoEncomenda.habilitadoValorDeclarado) {
        this.setState({ habilitadoValorDeclarado: this.props.dadosPagamentoEncomenda.habilitadoValorDeclarado, habilitaValorNotaFiscal: false });
        this.props.changeFieldValue('formularioCadastroEncomenda', 'valorProduto', this.props.dadosPagamentoEncomenda.valorProduto.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }));
      }
      if (this.props.dadosPagamentoEncomenda.habilitaValorNotaFiscal) {
        this.setState({ habilitadoValorDeclarado: false, habilitaValorNotaFiscal: this.props.dadosPagamentoEncomenda.habilitaValorNotaFiscal });
        this.limparCampoValorProduto();
      }
    } else {
      this.setState({ habilitadoValorDeclarado: false, habilitaValorNotaFiscal: false });
      this.limparCampoValorProduto();
    }
    this.carregarFormulario();
  }

  alterarValorCalculado = (event) => {
    let quantidadeKg = 0;
    const precoFixo = realParaNumber(this.props.precoFixo);
    const valorInformado = Number(event.target.value);

    let valorCalculado = 0;
    if (this.props.tipoCalculo.value === VALORPORKG) {
      quantidadeKg = realParaNumber(this.props.precoKg);
      valorCalculado = quantidadeKg * valorInformado;
    }

    if (this.props.tipoCalculo.value === PRECOFIXOMAISVALORPORKG) {
      quantidadeKg = realParaNumber(this.props.valorKg);
      valorCalculado = precoFixo + quantidadeKg * valorInformado;
    }

    const valorCalculadoFormatado = valorCalculado.toString()
      .replace('.', ',');
    this.props.adicionarDadosPagamentoEncomenda({ ...this.props.dadosPagamentoEncomenda, valorCalculado: valorCalculadoFormatado, quantidadeKg: valorInformado });
    this.props.changeFieldValue('formularioCadastroEncomenda',
      'valorCalculado', valorCalculadoFormatado);
  };

  exibirCamposValor() {
    if (this.props.tipoCalculo) {
      if (this.props.tipoCalculo.value === VALORCOMBINADO) {
        return (
          <div className="col-12 col-sm-12 col-md-2">
            <Field name='valorCombinado' validate={[required]}
              component={renderFieldMonetarioLabelEncima}
              className="form-control" label="Valor"
              handleChange={e => this.props.adicionarDadosPagamentoEncomenda({ ...this.props.dadosPagamentoEncomenda, valorCombinado: e.target.value })} />
          </div>
        )
      }
      if (this.props.tipoCalculo.value === VALORPORKG
        || this.props.tipoCalculo.value === PRECOFIXOMAISVALORPORKG) {
        return (
          <React.Fragment>
            {this.props.tipoCalculo.value === PRECOFIXOMAISVALORPORKG && <><div className="col-12 col-md-2">
              <Field name='precoFixo' validate={[required]} component={renderFieldMonetarioLabelEncima} className="form-control" label="Preço Fixo" readOnly />
            </div><div className="mt-5">
                <span>+</span>
              </div></>}

            {this.props.tipoCalculo.value === PRECOFIXOMAISVALORPORKG && <div className="col-12 col-md-2">
              <Field name='valorKg' validate={[required]} component={renderFieldMonetarioLabelEncima} className="form-control" label="Valor por KG" readOnly
              />
            </div>}

            {this.props.tipoCalculo.value === VALORPORKG && <div className="col-12 col-md-2">
              <Field name='precoKg' validate={[required]} component={renderFieldMonetarioLabelEncima} className="form-control" label="Valor por KG" readOnly
              />
            </div>}

            <div className="mt-5">
              <span>X</span>
            </div>
            <div className="col-12 col-md-2">
              <Field name='quantidadeKg' validate={[required]} component={renderFieldPercentual} className="form-control" label="Peso" handleChange={this.alterarValorCalculado.bind(this)} />
            </div>
            <div className="mt-5">
              <span>=</span>
            </div>
            <div className="col-12 col-md-2">
              <Field name='valorCalculado' validate={[required]} component={renderFieldMonetarioLabelEncima} className="form-control" label="Valor" readOnly />
            </div>
          </React.Fragment>
        )
      }
    }
  }

  exibirFormasPagamento() {
    if (this.props.dadosPagamentoEncomenda.formasPagamento.length) {
      return (<FormasPagamento exibeRemover
        verificarSeFormaPagamentoNaoFoiSelecionado={this.props.verificarSeFormaPagamentoNaoFoiSelecionado} />)
    }
  }

  limparFormularioNotaFiscal() {
    this.props.reset('formularioCadastroNotaFiscal');
    this.props.changeFieldValue('formularioCadastroNotaFiscal',
      'valor', '0');
    this.props.changeFieldValue('formularioCadastroNotaFiscal',
      'peso', '0');
    this.props.changeFieldValue('formularioCadastroNotaFiscal',
      'volume', '0');
    this.props.changeFieldValue('formularioCadastroNotaFiscal',
      'numeroDocumento', '');
  }

  sincronizarCalculoMetroCubico(itens, dadosBase = this.props.dadosPagamentoEncomenda) {
    const volumesPorLinha = itens.map(it => volumeUnitarioM3(it.comprimento, it.largura, it.altura));
    const volumeTotal = arredondamentoPadrao(volumesPorLinha.reduce((acc, v) => acc + v, 0));
    const precoM3 = realParaNumber(this.props.precoMetroCubico || '0');
    const valorCalculadoNum = arredondamentoPadrao(volumeTotal * precoM3);
    const volStr = volumeTotal.toFixed(3).replace('.', ',');
    const valStr = valorCalculadoNum.toFixed(2).replace('.', ',');
    const volumeEtiquetasItens = String(itens.length);
    this.props.adicionarDadosPagamentoEncomenda({
      ...dadosBase,
      itensMetroCubico: itens,
      volumeM3: volStr,
      valorCalculado: valStr,
      volume: volumeEtiquetasItens
    });
    this.props.changeFieldValue('formularioCadastroEncomenda', 'volumeTotalM3', volStr);
    this.props.changeFieldValue('formularioCadastroEncomenda', 'valorCalculado', valStr);
    this.props.changeFieldValue('formularioCadastroEncomenda', 'volumeEncomendas', volumeEtiquetasItens);
  }

  alterarCampoCaixaMetroCubico(index, campo, valor) {
    const itens = [...(this.props.dadosPagamentoEncomenda.itensMetroCubico || [])];
    if (!itens[index]) return;
    itens[index] = { ...itens[index], [campo]: valor };
    this.sincronizarCalculoMetroCubico(itens);
  }

  adicionarCaixaMetroCubico() {
    const base = this.props.dadosPagamentoEncomenda.itensMetroCubico || [];
    this.sincronizarCalculoMetroCubico([...base, novoItemMetroCubico()]);
  }

  removerCaixaMetroCubico(id) {
    const base = [...(this.props.dadosPagamentoEncomenda.itensMetroCubico || [])].filter(it => it.id !== id);
    this.sincronizarCalculoMetroCubico(base.length ? base : [novoItemMetroCubico()]);
  }

  alterarTipoCalculo(e) {
    if (e && e.value === VALOR_POR_METRO_CUBICO) {
      const itens = [novoItemMetroCubico()];
      const dadosBase = {
        ...this.props.dadosPagamentoEncomenda,
        tipoCalculo: e,
        valorCalculado: '0',
        quantidadeKg: '0',
        valorCombinado: '0',
        volumeM3: '0,000'
      };
      this.sincronizarCalculoMetroCubico(itens, dadosBase);
      return;
    }
    this.props.adicionarDadosPagamentoEncomenda({
      ...this.props.dadosPagamentoEncomenda,
      tipoCalculo: e,
      valorCalculado: '0',
      quantidadeKg: '0',
      valorCombinado: '0',
      volume: '0',
      volumeM3: '0,000',
      itensMetroCubico: []
    });
    this.props.changeFieldValue('formularioCadastroEncomenda', 'volumeTotalM3', '0,000');
  }

  exibirSecaoCalculoMetroCubico() {
    const itens = this.props.dadosPagamentoEncomenda.itensMetroCubico || [];
    const volumeTotalResumo = arredondamentoPadrao(itens.reduce(
      (acc, it) => acc + volumeUnitarioM3(it.comprimento, it.largura, it.altura), 0));
    const precoM3 = realParaNumber(this.props.precoMetroCubico || '0');
    const valorTotalResumo = arredondamentoPadrao(volumeTotalResumo * precoM3);

    let exemploFormula = null;
    const primeiraCaixa = itens[0];
    if (primeiraCaixa) {
      const c = parseDimensaoCm(primeiraCaixa.comprimento);
      const l = parseDimensaoCm(primeiraCaixa.largura);
      const a = parseDimensaoCm(primeiraCaixa.altura);
      if (c > 0 && l > 0 && a > 0) {
        const vuExemplo = volumeUnitarioM3(primeiraCaixa.comprimento, primeiraCaixa.largura, primeiraCaixa.altura);
        const rotuloCaixa = (primeiraCaixa.descricao && String(primeiraCaixa.descricao).trim()) || '1ª caixa';
        exemploFormula = (
          <p className="encomenda-metro-cubico-formula-exemplo">
            Ex.: <strong>{rotuloCaixa}</strong> — ({c.toLocaleString('pt-BR')} × {l.toLocaleString('pt-BR')} × {a.toLocaleString('pt-BR')}) / 1.000.000 ={' '}
            <strong>{vuExemplo.toLocaleString('pt-BR', { minimumFractionDigits: 3, maximumFractionDigits: 3 })} m³</strong>
          </p>
        );
      }
    }

    return (
      <div className="col-12 encomenda-metro-cubico-wrap">
        <div className="encomenda-metro-cubico-titulo">Cálculo do Metro Cúbico</div>
        <div className="row align-items-start">
          <div className="col-12 col-lg-8 col-xl-8 pr-lg-4 mb-4 mb-lg-0">
            <fieldset className="encomenda-metro-cubico-fieldset">
              <legend>Adicionar Caixas</legend>
              <div className="table-responsive">
                <table className="table table-bordered table-sm mb-0 encomenda-metro-cubico-table">
                  <thead>
                    <tr>
                      <th rowSpan={2} className="text-center align-middle" style={{ width: '48px' }}>#</th>
                      <th rowSpan={2} className="align-middle" style={{ minWidth: '160px' }}>Descrição da Caixa</th>
                      <th colSpan={3} className="text-center align-middle">Dimensões (cm)</th>
                      <th rowSpan={2} className="text-center align-middle" style={{ minWidth: '128px' }}>Volume Unitário (m³)</th>
                      <th rowSpan={2} className="text-center align-middle" style={{ width: '72px' }}>Ações</th>
                    </tr>
                    <tr>
                      <th className="text-center">Comprimento (C)</th>
                      <th className="text-center">Largura (L)</th>
                      <th className="text-center">Altura (A)</th>
                    </tr>
                  </thead>
                  <tbody>
                    {itens.map((it, idx) => {
                      const vu = volumeUnitarioM3(it.comprimento, it.largura, it.altura);
                      return (
                        <tr key={it.id}>
                          <td className="text-center text-muted">{idx + 1}</td>
                          <td>
                            <input type="text" className="form-control form-control-sm" value={it.descricao}
                              placeholder="Ex.: Caixa 1"
                              onChange={ev => this.alterarCampoCaixaMetroCubico(idx, 'descricao', ev.target.value)} />
                          </td>
                          <td className="encomenda-metro-cubico-col-dim">
                            <input type="text" className="form-control form-control-sm" inputMode="decimal"
                              placeholder="cm"
                              value={it.comprimento}
                              onChange={ev => this.alterarCampoCaixaMetroCubico(idx, 'comprimento', ev.target.value)} />
                          </td>
                          <td className="encomenda-metro-cubico-col-dim">
                            <input type="text" className="form-control form-control-sm" inputMode="decimal"
                              placeholder="cm"
                              value={it.largura}
                              onChange={ev => this.alterarCampoCaixaMetroCubico(idx, 'largura', ev.target.value)} />
                          </td>
                          <td className="encomenda-metro-cubico-col-dim">
                            <input type="text" className="form-control form-control-sm" inputMode="decimal"
                              placeholder="cm"
                              value={it.altura}
                              onChange={ev => this.alterarCampoCaixaMetroCubico(idx, 'altura', ev.target.value)} />
                          </td>
                          <td className="encomenda-metro-cubico-col-vol align-middle">
                            {vu.toLocaleString('pt-BR', { minimumFractionDigits: 3, maximumFractionDigits: 3 })}
                          </td>
                          <td className="text-center align-middle">
                            <button type="button" className="btn btn-link p-1" title="Remover caixa"
                              onClick={() => this.removerCaixaMetroCubico(it.id)}>
                              <i className="material-icons nav-icon" style={{ color: '#e53935', fontSize: '22px' }}>&#xe872;</i>
                            </button>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
              <button type="button"
                className="btn encomenda-metro-cubico-btn-adicionar"
                onClick={() => this.adicionarCaixaMetroCubico()}>
                <i className="material-icons" style={{ fontSize: '20px' }}>&#xe145;</i>
                Adicionar outra caixa
              </button>
            </fieldset>
          </div>
          <div className="col-12 col-lg-4 col-xl-4">
            <div className="encomenda-metro-cubico-sidebar">
              <div className="encomenda-metro-cubico-formula">
                <strong>Fórmula</strong>
                <div className="encomenda-metro-cubico-formula-expr">m³ = (C × L × A) / 1.000.000</div>
                {exemploFormula || (
                  <p className="encomenda-metro-cubico-formula-exemplo mb-0">
                    Informe comprimento, largura e altura em centímetros para ver um exemplo com a primeira caixa.
                  </p>
                )}
              </div>
              <div className="encomenda-metro-cubico-resumo">
                <div className="encomenda-metro-cubico-resumo-titulo">Resumo do Volume</div>
                <div className="encomenda-metro-cubico-resumo-linha">
                  <strong>Total de caixas:</strong> {itens.length}
                </div>
                <div className="encomenda-metro-cubico-resumo-valor-label">Volume total</div>
                <div className="encomenda-metro-cubico-resumo-valor">
                  {volumeTotalResumo.toLocaleString('pt-BR', { minimumFractionDigits: 3, maximumFractionDigits: 3 })} m³
                </div>
                <div className="encomenda-metro-cubico-resumo-valor-total">
                  <div className="encomenda-metro-cubico-resumo-valor-label">Valor total (volume × R$/m³)</div>
                  <div className="encomenda-metro-cubico-resumo-valor">
                    {valorTotalResumo.toLocaleString('pt-BR', {
                      style: 'currency',
                      currency: 'BRL'
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  handleCheckedValorDeclarao() {
    if (!this.props.configuracaoEncomenda.habilitadoTaxaSeguro) {
      showAlertMsg('A taxa de seguro não foi configurado!')
      return;
    }

    let taxaSeguro = 0;
    if (this.props.configuracaoEncomenda.habilitadoTaxaSeguro) {
      taxaSeguro = realParaNumber(this.props.configuracaoEncomenda.taxaSeguro) / 100;
    }

    if (this.state.habilitadoValorDeclarado) {
      this.props.adicionarDadosPagamentoEncomenda({
        ...this.props.dadosPagamentoEncomenda,
        habilitadoValorDeclarado: false,
        valorProduto: 0,
        habilitadoSeguro: this.state.habilitaValorNotaFiscal,
      });
      this.setState({
        habilitadoValorDeclarado: !this.state.habilitadoValorDeclarado
      });

      this.limparCampoValorProduto();
      this.limparCamposValoresDinheiroCartao();

    } else {
      this.props.adicionarDadosPagamentoEncomenda({
        ...this.props.dadosPagamentoEncomenda,
        habilitadoValorDeclarado: true,
        valorProduto: this.props.valorProduto ? this.props.valorProduto : 0,
        habilitaValorNotaFiscal: false,
        habilitadoSeguro: true,
        taxaSeguro: taxaSeguro,
        valorSeguro: this.props.valorProduto ? realParaNumber(this.props.valorProduto) * taxaSeguro : 0
      });

      this.setState({
        habilitadoValorDeclarado: !this.state.habilitadoValorDeclarado,
        habilitaValorNotaFiscal: false
      });

    }

  }

  handleCheckedValorNotaFiscal() {
    if (!this.props.configuracaoEncomenda.habilitadoTaxaSeguro) {
      showAlertMsg('A taxa de seguro não foi configurado!');
      return;
    }

    let taxaSeguro = 0;
    if (this.props.configuracaoEncomenda.habilitadoTaxaSeguro) {
      taxaSeguro = realParaNumber(this.props.configuracaoEncomenda.taxaSeguro) / 100;
    }
    if (this.state.habilitaValorNotaFiscal) {
      this.props.adicionarDadosPagamentoEncomenda({
        ...this.props.dadosPagamentoEncomenda,
        habilitaValorNotaFiscal: false,
        habilitadoSeguro: this.state.habilitadoValorDeclarado,
        valorProduto: this.props.valorProduto ? this.props.valorProduto : 0,
      });
      this.setState({
        habilitaValorNotaFiscal: !this.state.habilitaValorNotaFiscal
      });

      this.limparCamposValoresDinheiroCartao();

    } else {
      this.props.adicionarDadosPagamentoEncomenda({
        ...this.props.dadosPagamentoEncomenda,
        habilitadoValorDeclarado: false,
        valorProduto: 0,
        habilitaValorNotaFiscal: true,
        taxaSeguro: taxaSeguro,
        habilitadoSeguro: true
      });
      this.setState({
        habilitadoValorDeclarado: false,
        habilitaValorNotaFiscal: !this.state.habilitaValorNotaFiscal
      });

      this.limparCampoValorProduto();
    }
  }

  exibeCamposSeguro() {
    return (
      <div className='mt-4'>
        <div className="form-row">
          <label>Cobrar Seguro Por: </label>
        </div>
        <div className='col-12 col-sm-8 col-md-8'>
          <div className="form-row" style={{ alignItems: 'flex-end' }}>
            <div className='form-group form-check col-12 col-sm-3 col-md-3'>
              <input type="checkbox" name='habilitadoValorDeclarado'
                className='form-check-input' onChange={this.handleCheckedValorDeclarao.bind(this)} value={this.state.habilitadoValorDeclarado} checked={this.state.habilitadoValorDeclarado} />
              <label className='form-check-label'>Valor declarado:</label>
            </div>
            {this.state.habilitadoValorDeclarado && (
              <div className='col-12 col-sm-3 col-md-3'>
                <Field
                  name="valorProduto"
                  validate={[maxValueMonetario, required]}
                  component={renderFieldMonetarioLabelEncima}
                  label="Valor do produto:"
                  handleChange={(e) => this.adicionarValorProduto(e)}
                />
              </div>)}
          </div>
        </div>
        <div className='col-12 col-sm-8 col-md-8'>
          <div className="form-row mb-2">
            <div className='form-group form-check col-12 col-sm-3 col-md-3'>
              <input type="checkbox" name='habilitaValorNotaFiscal'
                className='form-check-input' onChange={this.handleCheckedValorNotaFiscal.bind(this)} value={this.state.habilitaValorNotaFiscal} checked={this.state.habilitaValorNotaFiscal} />
              <label className='form-check-label'>Valor nota fiscal:</label>
            </div>
          </div>
        </div>

      </div>
    )
  }

  carregarFormulario() {

    this.props.changeFieldValue('formularioCadastroEncomenda', 'base64ImagemEncomenda', null);
    this.props.changeFieldValue('formularioCadastroEncomenda', 'nomeImagemEncomenda', null);
    this.props.changeFieldValue('formularioCadastroEncomenda', 'urlImagem', null);

    if (this.props.base64ImagemEncomenda || this.props.urlImagem) {
      const imagens = this.props.configuracaoEncomenda.imagens.map(it => {
        return {
          hash: gerarHashForString(`${it.nome}`),
          ...it
        }
      });
      this.setState({ arquivos: imagens });
    }

  }

  handleChange(event) {
    const chooseFiles = Array.prototype.slice.call(event.target.files);
    const arquivos = [...this.state.arquivos];

    const mensagens = [];

    const mensagem = {
      tipo: 'erro',
      nomeArquivo: '',
      texto: 'Limite excedido de arquivos para upload.'
    };

    if (chooseFiles.length > LIMITE_UPLOAD_ARQUIVO_ENCOMENDA) {
      mensagem.nomeArquivo = chooseFiles[chooseFiles.length - 1].name;
      mensagens.push(mensagem);
      this.setState({ mensagens });
      return;
    }

    const limite = arquivos.length + chooseFiles.length;

    chooseFiles.forEach(file => {
      if (arquivos.findIndex(arq => arq.nome === file.name) === -1) {
        if (/\.(jpe?g|png|webp)$/i.test(file.name) === false) {
          const mensagem = {
            tipo: 'erro',
            nomeArquivo: file.name,
            texto: 'Formato de imagem inválido. Informe uma imagem nos formatos JPEG, PNG ou JPG.'
          };
          mensagens.push(mensagem);
        } else if (limite >= 0 && arquivos.length > LIMITE_UPLOAD_ARQUIVO_ENCOMENDA) {
          const mensagem = {
            tipo: 'erro',
            nomeArquivo: file.name,
            texto: 'Limite excedido de arquivos para upload.'
          };
          mensagens.push(mensagem);
          return;
        } else if (file.size > tamanhoArquivoUpload) {
          const mensagem = {
            tipo: 'erro',
            nomeArquivo: file.name,
            texto: 'Tamanho do arquivo excede 20 MB.'
          };
          mensagens.push(mensagem);
        } else {
          this.converterParaBase64(file);
        }
      }
    })

    this.setState({ mensagens });
  }

  converterParaBase64(file) {
    const obj = {
      hash: gerarHashForString(`${file.name}`),
      nome: file.name,
      base64ImagemEncomenda: null,
      urlImagem: null,
    };

    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      const arquivos = [...this.state.arquivos];
      obj.base64ImagemEncomenda = reader.result;
      obj.urlImagem = reader.result;
      arquivos.push(obj);

      this.setState({ arquivos });
      this.props.adicionaEhRemoveImagensEncomenda(arquivos);
    }.bind(this);
    reader.onerror = function () {
      const mensagem = {
        tipo: 'erro',
        nomeArquivo: file.name,
        texto: 'Imagem inválida. Selecione outra imagem.'
      };
      const mensagens = [...this.state.mensagens];
      mensagens.push(mensagem);
      this.setState({ mensagens });
      this.removerImagem(obj);
    }.bind(this);
  }

  exibirImagem() {
    return (
      <>
        {this.state.arquivos.map((arq, index) => (
          <Fragment key={`file-${index}`}>
            <ImageGridUpload key={`file-${index}`} setSelectedImg={this.setSelectedImg.bind(this)} file={arq} removerImagem={this.removerImagem.bind(this)}/>
          </Fragment>
        ))}

        {this.state.selectedImg && <Modal selectedImg={this.state.selectedImg} setSelectedImg={this.setSelectedImg.bind(this)} />}
      </>
    )

  }

  removerImagem(arquivo) {
    const arquivos = [...this.state.arquivos];
    const array = arquivos.filter(it => it.hash != arquivo.hash);

    this.setState({ arquivos: array });
    this.props.adicionaEhRemoveImagensEncomenda(array);
  }

  setSelectedImg(selectedImg) {
    this.setState({ selectedImg })
  }

  limparMensagem() {
    this.setState({ mensagens: [] });
  }

  adicionarValorProduto(e) {
    let valorProduto = 0;
    if (e.target.value) {
      valorProduto = realParaNumber(e.target.value.replace('R$', ''));
    }

    let valorSeguro = 0;
    let taxaSeguro = 0;
    if (this.props.configuracaoEncomenda.habilitadoTaxaSeguro) {
      taxaSeguro = realParaNumber(this.props.configuracaoEncomenda.taxaSeguro) / 100;
      valorSeguro = valorProduto * taxaSeguro;
    }

    this.props.adicionarDadosPagamentoEncomenda({ ...this.props.dadosPagamentoEncomenda, valorProduto, valorSeguro });
  }

  limparCampoValorProduto() {
    this.props.changeFieldValue('formularioCadastroEncomenda', 'valorProduto', '0');
  }

  limparCamposValoresDinheiroCartao() {
    this.props.changeFieldValue('formularioCadastroEncomenda', 'valorDinheiro', '0');
    this.props.changeFieldValue('formularioCadastroEncomenda', 'valorCartao', '0');
  }

  render() {
    return (
      <React.Fragment>
        <div className="form-row mb-2">
          <div className="col-12 col-md-2">
            <Field name="tipoProduto" type="text" validate={[required]} required={true} component={renderFieldText} label="Descrição do produto:"
              css="form-control" readOnly={false} onChange={e => this.props.adicionarDadosPagamentoEncomenda({ ...this.props.dadosPagamentoEncomenda, tipoProduto: e.target.value })} />
          </div>
          <div className="col-12 col-md-2">
            <Field name='tipoCalculo'
              options={this.props.tiposCalculoEncomenda.map(it => ({
                nome: it.chave,
                descricao: it.valor
              }))}
              component={renderFieldSelect}
              label='Tipo de cálculo'
              placeholder='Selecione...'
              validate={requiredSelect}
              onChange={this.alterarTipoCalculo}
            />
          </div>
          {this.props.tipoCalculo && (
          <div className="col-12 col-md-1">
            <Field name='volumeEncomendas' css="form-control" validate={[required]} component={renderFieldNumeros} label="Volume"
              readOnly={this.props.tipoCalculo.value === VALOR_POR_METRO_CUBICO}
              onChange={this.props.tipoCalculo.value === VALOR_POR_METRO_CUBICO
                ? undefined
                : (e => this.props.adicionarDadosPagamentoEncomenda({ ...this.props.dadosPagamentoEncomenda, volume: e.target.value }))} />
          </div>
          )}
          {this.props.tipoCalculo && this.props.tipoCalculo.value === VALOR_POR_METRO_CUBICO && (
          <React.Fragment>
            <div className="col-12 col-md-2">
              <Field name='precoMetroCubico' validate={[required]} component={renderFieldMonetarioLabelEncima} className="form-control" label="Valor por m³ (R$)" readOnly />
            </div>
            <div className="mt-5"><span>×</span></div>
            <div className="col-12 col-md-2">
              <Field name='volumeTotalM3' css="form-control" validate={[required]} component={renderFieldText} label="Volume total (m³)" readOnly />
            </div>
            <div className="mt-5"><span>=</span></div>
            <div className="col-12 col-md-2">
              <Field name='valorCalculado' validate={[required]} component={renderFieldMonetarioLabelEncima} className="form-control" label="Total" readOnly />
            </div>
          </React.Fragment>
          )}
          {this.props.tipoCalculo && (this.props.tipoCalculo.value === VALORPORKG || this.props.tipoCalculo.value == VALORCOMBINADO) && this.exibirCamposValor()}
        </div>
        {this.props.tipoCalculo && this.props.tipoCalculo.value === PRECOFIXOMAISVALORPORKG && <div className="form-row">
          {this.exibirCamposValor()}
        </div>}
        {this.props.tipoCalculo && this.props.tipoCalculo.value === VALOR_POR_METRO_CUBICO && this.exibirSecaoCalculoMetroCubico()}
        <div className='input-wrapper mt-3'>
          <label htmlFor='input-file'>
            {this.props.logoMarca ? 'Alterar imagens encomenda' : 'Adicionar imagens encomenda'}
          </label>
          <input id='input-file' type='file' value='' accept="image/*" onChange={this.handleChange.bind(this)} multiple />
          <span id='file-name' />
        </div>
        <div className='img-grid mt-4'>
          {this.exibirImagem()}
        </div>
        {this.exibeCamposSeguro()}
        <div>
          <div className="col-12 titulo-principal">
            <FormCadastroNotaFiscal />
          </div>

          <div className='col-12'>
            <NotasFiscais notasFiscais={this.props.dadosPagamentoEncomenda.notasFiscais} exibeRemover />
          </div>
        </div>
        <div className="col-12 mt-3">
          <div className="vx-enc-card">
            <div className="vx-enc-card-header">
              <i className="material-icons">summarize</i>
              <span className="vx-enc-card-title">Resumo da Encomenda</span>
            </div>
            <div className="vx-enc-card-body">
              {this.props.tipoCalculo && this.props.tipoCalculo.value === VALOR_POR_METRO_CUBICO && (
                <>
                  <div className="vx-enc-resumo-row">
                    <span className="vx-enc-resumo-label">Valor por m³</span>
                    <span className="vx-enc-resumo-value">{realParaNumber(this.props.precoMetroCubico || '0').toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</span>
                  </div>
                  <div className="vx-enc-resumo-row">
                    <span className="vx-enc-resumo-label">Volume (etiquetas)</span>
                    <span className="vx-enc-resumo-value">{this.props.dadosPagamentoEncomenda.volume}</span>
                  </div>
                  <div className="vx-enc-resumo-row">
                    <span className="vx-enc-resumo-label">Volume total</span>
                    <span className="vx-enc-resumo-value">{this.props.dadosPagamentoEncomenda.volumeM3 || '0,000'} m³</span>
                  </div>
                </>
              )}
              <div className="vx-enc-resumo-row">
                <span className="vx-enc-resumo-label">Valor</span>
                <span className="vx-enc-resumo-value">{this.props.recuperarValorTotal().toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</span>
              </div>
              {this.props.dadosPagamentoEncomenda.habilitadoSeguro && (
                <>
                  <div className="vx-enc-resumo-row">
                    <span className="vx-enc-resumo-label">Valor Seguro</span>
                    <span className="vx-enc-resumo-value">{this.props.calcularValorSeguro().toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</span>
                  </div>
                  <div className="vx-enc-resumo-row">
                    <span className="vx-enc-resumo-label">Valor Total</span>
                    <span className="vx-enc-resumo-value vx-orange">{this.props.recuperarValorTotalGeral().toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</span>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
        <div className="col-12 mt-3">
          <div className="vx-enc-card">
            <div className="vx-enc-card-header">
              <i className="material-icons">payments</i>
              <span className="vx-enc-card-title">Forma de Pagamento</span>
            </div>
            <div className="vx-enc-card-body">
              {this.props.dadosPagamentoEncomenda.tipoCalculo
                ? <FormCadastrarFormaPagamentoEncomenda
                    verificarSeFormaPagamentoNaoFoiSelecionado={this.props.verificarSeFormaPagamentoNaoFoiSelecionado} />
                : ''}
              {this.exibirFormasPagamento()}
            </div>
          </div>
        </div>
      </React.Fragment>
    )
  }
}

export const mapStateToProps = state => {
  return {
    empresaSelecionada: state.empresaSelecionada,
    notasFiscais: state.notasFiscais,
    tipoCalculo: selector(state, 'tipoCalculo'),
    volumeEncomendas: selector(state, 'volumeEncomendas'),
    quantidadeKg: selector(state, 'quantidadeKg'),
    dadosPagamentoEncomenda: state.dadosPagamentoEncomenda,
    habilitadoPrecoKg: state.configuracaoEncomenda.habilitadoPrecoKg,
    precoKg: state.configuracaoEncomenda.precoKg,
    habilitadoPrecoFixoMaisValorKg: state.configuracaoEncomenda.habilitadoPrecoFixoMaisValorKg,
    valorKg: state.configuracaoEncomenda.valorKg,
    precoFixo: state.configuracaoEncomenda.precoFixo,
    precoMetroCubico: state.configuracaoEncomenda.precoMetroCubico,
    tiposCalculoEncomenda: state.configuracaoEncomenda.tiposCalculoEncomenda,
    valorProduto: selector(state, 'valorProduto'),
    configuracaoEncomenda: state.configuracaoEncomenda,
    base64ImagemEncomenda: selector(state, 'base64ImagemEncomenda'),
    nomeImagemEncomenda: selector(state, 'nomeImagemEncomenda'),
    urlImagem: selector(state, 'urlImagem'),
    initialValues: {
      habilitadoPrecoKg: state.configuracaoEncomenda.habilitadoPrecoKg,
      precoKg: state.configuracaoEncomenda.precoKg,
      habilitadoPrecoFixoMaisValorKg: state.configuracaoEncomenda.habilitadoPrecoFixoMaisValorKg,
      valorKg: state.configuracaoEncomenda.valorKg,
      precoFixo: state.configuracaoEncomenda.precoFixo,
      precoMetroCubico: state.configuracaoEncomenda.precoMetroCubico,
      tipoProduto: state.dadosPagamentoEncomenda.tipoProduto,
      tipoCalculo: state.dadosPagamentoEncomenda.tipoCalculo,
      volumeEncomendas: state.dadosPagamentoEncomenda.volumeEncomendas || state.dadosPagamentoEncomenda.volume,
      volumeTotalM3: state.dadosPagamentoEncomenda.volumeM3 || '0,000',
      quantidadeKg: state.dadosPagamentoEncomenda.quantidadeKg,
      valorCalculado: state.dadosPagamentoEncomenda.valorCalculado,
      valorCombinado: state.dadosPagamentoEncomenda.valorCombinado,

    }
  }
};


export default connect(mapStateToProps, { changeFieldValue, adicionaEhRemoveImagensEncomenda, adicionarDadosPagamentoEncomenda })(reduxForm({
  form: 'formularioCadastroEncomenda',
  enableReinitialize: true,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
})(AbaPagamento))
